import React, {useState, useEffect} from 'react';
import * as ReactUtils from "../utils/ReactUtils.js";
import * as Utils from '../utils/Utils.js';
import ImageActionBar from './components/ImageActionBar'; 
import rocketloadingImage from "../images/rocket.gif";

const CreateImage = ({ isUserSignedIn, isUserSubscribed, userEmail, accessToken }) => {
  const [countOfLeftCredits, setCountOfLeftCredits] = useState(
    isUserSubscribed ? Utils.getCountOfLeftCreditsForThisMonth(Utils.USER_PROPERTY_COUNT_OF_LEFT_CREATED_IMAGES_THIS_MONTH, Utils.CREATED_IMAGE_CREDITS_EVERY_MONTH) : 0);
  const [createdImageUrl, setCreatedImageUrl] = useState('');

  useEffect(() => {
    // console.log("here", isUserSignedIn, isUserSubscribed);
    if (isUserSignedIn) {
      if (isUserSubscribed) {
        updateUIWithLeftCredits(countOfLeftCredits);
      } else {  
        Utils.showHTMLElement(document.getElementById("createImageOnlyAvailabletoPremium"));
      }
    }
  }, [isUserSignedIn, isUserSubscribed]);

  const updateUIWithLeftCredits = () => {
    // console.debug("updateUIWithLeftCredits", leftImageCredits);
    document.getElementById("leftCreditsThisMonthId").textContent = "(" + countOfLeftCredits + " images left for this month)";
    if (countOfLeftCredits <= 0) {
      document.getElementById("workGPT_createImageButtonId").disabled = true;
      Utils.showHTMLElement(document.getElementById("workGPT_noCreditsThisMonthId"));
    }
  }
  
  const showError = (msg) => {
    document.getElementById("workGPT_createdImage").src = "";
    setCreatedImageUrl('');
    alert(msg);
  }

  const handleCreateImageButtonClicked = async () => {
    if (!isUserSignedIn) {
      ReactUtils.showUserSignInOrOutPopup(null, document.getElementById("workGPT_createImageFieldId"), true, Utils.reloadUI);
    } else if (!isUserSubscribed) {
      ReactUtils.PurchasePremiumPopup(document.getElementById("workGPT_createImageFieldId"), userEmail);
    } else {
      try {
        if (countOfLeftCredits <= 0) {
          alert(`You don't have image credits left for this month.`);
          return;
        }

        if (!document.getElementById("workGPT_createImageFieldId").value) {
          alert(`Please enter the text to create image`);
          return;
        }
        
        const $dimmer = document.getElementById('workGPT_loadingDimmer');
        Utils.showLoadingDimmer($dimmer);

        const createImageResponse = await Utils.gptCreateImageHttp(
          accessToken, document.getElementById("workGPT_createImageFieldId").value, 
          document.getElementById("workGPT_sizeOfTheImageToCreateSectionId").value);

        Utils.hideLoadingDimmer($dimmer);
        if (createImageResponse) {
          if (createImageResponse[Utils.HTTP_ERROR]) {
            showError(createImageResponse[Utils.HTTP_ERROR]);
          } else {
            document.getElementById("workGPT_createdImage").src = createImageResponse[Utils.HTTP_RESPONSE];
            setCreatedImageUrl(createImageResponse[Utils.HTTP_RESPONSE]);

            const leftCredits = Utils.decrementCreditUsageForThisMonth(Utils.USER_PROPERTY_COUNT_OF_LEFT_CREATED_IMAGES_THIS_MONTH);
            setCountOfLeftCredits(leftCredits);
            updateUIWithLeftCredits();
          }
        } else {
          showError("Create image failed with empty response");
        }
      } catch (error) {
        console.error('Create Image Error: ', error);
        showError('Create Image failed: ', error.message);
      } 
    }
  }

  const handleEditImageButtonClick = async() => {
    try {
      const $dimmer = document.getElementById('editedImage_loadingDimmer');
      Utils.showLoadingDimmer($dimmer);
      const editImageResponse = await Utils.gptEditImageHttp('', createdImageUrl, document.getElementById("editedImage_imageEditInputId").value, 
          document.getElementById("editedImage_sizeOfTheImageToCreateSectionId").value, accessToken);
      
      Utils.hideLoadingDimmer($dimmer);
      if (editImageResponse) {
        if (editImageResponse[Utils.HTTP_ERROR]) {
          alert('Edit Image failed: ' + editImageResponse[Utils.HTTP_ERROR]);
        } else {
          document.getElementById("workGPT_createdImage").src = editImageResponse[Utils.HTTP_RESPONSE];
          setCreatedImageUrl(editImageResponse[Utils.HTTP_RESPONSE]);
        }
      } else {
        alert("Edit image failed with empty response");
      }
    } catch (error) {
      console.error('Edit Image Error:', error);
      alert('Edit Image failed: ', error.message);
    }
  }

  return (
    <div style={{marginLeft: "6px", marginRight: "10px"}}>
      {/* <div style={{fontSize: "17px", fontWeight: 600, marginTop: "0px", color: "#4285F4"}}>Create Image Beta <span id="leftCreditsThisMonthId" style={{color: "gray"}}>({leftImageCreditsThisMonth} left for this month)</span></div> */}
      <div style={{color: "gray", marginTop: "10px"}}>What image or logo to create? (e.g. A logo about ice cream, A cute baby sea otter, or generate a map of a kingdom with castles and rivers etc)</div>
      
      <textarea id="workGPT_createImageFieldId" style={{height: "80px", maxWidth: "900px", margin: "16px 20px 20px 0px"}} ></textarea>
      <label style={{color: "gray", paddingRight: "5px"}}>Size of the image to create</label>
      <select id="workGPT_sizeOfTheImageToCreateSectionId" style={{display: "inline"}}>
        <option value="256x256" selected>256x256</option>
        <option value="512x512">512x512</option>
        <option value="1024x1024">1024x1024</option>
      </select>
      <label id="leftCreditsThisMonthId" style={{color: "gray", float: "right"}}></label>
      <div id="createImageOnlyAvailabletoPremium" style={{color: "red", marginTop: "10px", display: "none"}}>Create Image feature is only available to Premium and Enterprise users. Upgrade and create more images!</div>
      <div style={{marginTop: "20px"}}>
        <button id="workGPT_createImageButtonId" className="medium ui button" onClick={handleCreateImageButtonClicked}
          style={{backgroundColor: "rgb(0, 119, 255)", color: "white"}}>
          <b>Create Image</b></button>
      </div>
      <div id="workGPT_noCreditsThisMonthId" style={{color: "#ff0000", display: "none", marginTop: "20px"}}>You don't have image credits left for this month, please try creating more images next month, or upgrade to Enterprise service and get more image credits!</div>
      
      <div id= "workGPT_loadingDimmer" className="ui inverted dimmer">
        <div className="ui indeterminate text loader"></div>
        <img src={rocketloadingImage} style={{width: "24px", marginTop: "-12px"}} alt="rocket" />
      </div>

      
      {/* SECTION: CREATED IMAGE SECTION */}
      <div className="ui divider"></div>
      <div className="medium-text" style={{color: "green", marginTop: "10px"}}>Created Image</div>
      <img id="workGPT_createdImage" className="ui medium rounded bordered image" src="" alt="Created Image" style={{marginTop: "20px"}} />      
      { createdImageUrl && <div id= "imageActionsBar" style={{marginTop: "6px"}}>
          <ImageActionBar imageUrl={createdImageUrl} redoImage={handleEditImageButtonClick}></ImageActionBar>
          <div style={{marginTop: "16px"}}>
            <input type="text" id="workGPT_imageEditInputId" style={{display: 'inline', minWidth: '300px', marginRight: '16px'}}
              placeholder="Enter how to edit image, e.g. remove text, replace text with..."/>
            <button className="ui edit outline icon basic tiny button" onClick={handleEditImageButtonClick} 
                style={{marginTop: '2px'}}><i className="edit outline icon"></i> Edit and update image
            </button>
          </div>
        </div>
      }
    </div>
  );
};

export default CreateImage;   


// <div className="ui large secondary menu" style={{paddingTop: '20px', paddingBottom: '20px'}}>
//       <div style={{ display: 'flex', alignItems: 'center', marginRight: '30px' }}>
//         <img src={appLogo} alt="logo" style={{ width: '30px', height: '30px', marginRight: '8px' }} />
//         <div className="common-font" style={{ fontSize: '19px', display: 'inline', fontWeight: '500' }}>WorkGPT</div>
//       </div>

//       <a className="item common-font" href="/">Home</a>
//     </div>




// async function getCountOfLeftImagesForThisMonth() {
//   let user = await AuthUtils.currentAuthenticatedUser();
//   let userUsage = user.attributes[USER_ATTRIBUTES_USER_USAGE];

//   if (userUsage) {

//   } else {

//   }

//   const leftImagesResetDate = user.attributes[USER_ATTRIBUTES_LEFT_IMAGES_RESET_DATE];
//   const today = new Date();
//   const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);

//   if (currentCredits === undefined || currentCredits === null || new Date(leftImagesResetDate) < currentMonthStart) {
//     // If property doesn't exist or the month has changed, reset to 50 credits
//     currentCredits = IMAGE_CREDITS_EVERY_MONTH;
//     Utils.setLocalStorageProperty(USER_PROPERTY_COUNT_OF_LEFT_IMAGES_THIS_MONTH, currentCredits.toString());
//     Utils.setLocalStorageProperty(USER_PROPERTY_LEFT_IMAGES_RESET_DATE, currentMonthStart.toISOString());
//   } else {
//     currentCredits = Number(currentCredits); // Parse the stored value as a float
//   }

//   return currentCredits;



//   USER_ATTRIBUTES_COUNT_OF_LEFT_IMAGES_THIS_MONTH = "custom:count_of_left_images_this_month";
// const USER_ATTRIBUTES_LEFT_IMAGES_RESET_DATE 
//   if (!user.attributes['custom:origin_platform']) {
//     let result = await AuthUtils.updateUserAttributes(user, { 'custom:origin_platform': Utils.PLATFORM_TYPE.WEB });
//     console.debug('User attributes updated:', result);
//   }




//   const today = new Date();
//   const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
//   let currentCredits = Utils.getLocalStorageProperty(USER_PROPERTY_COUNT_OF_LEFT_IMAGES_THIS_MONTH);
//   const leftImagesResetDate = Utils.getLocalStorageProperty(USER_PROPERTY_LEFT_IMAGES_RESET_DATE);

//   if (currentCredits === undefined || currentCredits === null || new Date(leftImagesResetDate) < currentMonthStart) {
//     // If property doesn't exist or the month has changed, reset to 50 credits
//     currentCredits = IMAGE_CREDITS_EVERY_MONTH;
//     Utils.setLocalStorageProperty(USER_PROPERTY_COUNT_OF_LEFT_IMAGES_THIS_MONTH, currentCredits.toString());
//     Utils.setLocalStorageProperty(USER_PROPERTY_LEFT_IMAGES_RESET_DATE, currentMonthStart.toISOString());


//   } else {
//     currentCredits = Number(currentCredits); // Parse the stored value as a float
//   }

//   return currentCredits;
//}
